import { getCurrentInstance, computed, unref } from "vue";
import { u as useColors } from "./useColors-6d98be99.mjs";
const useTextColor = (componentColor, isTransparent = false) => {
  const { props } = getCurrentInstance();
  const { getColor, getTextColor } = useColors();
  const textColorComputed = computed(() => {
    if (props.textColor) {
      return getColor(props.textColor);
    }
    const componentColorHex = getColor(unref(componentColor) || props.color);
    return unref(isTransparent) ? componentColorHex : getColor(getTextColor(componentColorHex));
  });
  return { textColorComputed };
};
export {
  useTextColor as u
};
//# sourceMappingURL=useTextColor-d6b2d8c3.mjs.map
